const clickConnect = () => {
    console.log("Connecting to wallet...");
    // Your wallet connection logic here
  };
  
  export default clickConnect;